import React, {useEffect, useState} from "react";
import MainPanel from "src/components/main/MainPanel";
import {VirtualWindowDataResponse} from "src/model/VirtualWindowDataResponse";
import FilkersLoading from "src/components/commons/FilkersLoading";

const PreviewPage = () => {

    const [previewData, setPreviewData] = useState<VirtualWindowDataResponse>();
    const [selectedItemUid, setSelectedItemUid] = useState<string>(undefined);

    useEffect(() => {

        // Registramos un listener para recibir los datos de preview
        const previewDataReceiver = (event) => {
            const {origin, data} = event;
            if (origin.startsWith("http://devel.filkers.com") || origin.startsWith("https://app.filkers.com")) {
                setPreviewData(data);
            }
        }

        window.addEventListener('message', previewDataReceiver);

        // Notificamos que estamos listos para recibirlos
        window.top.postMessage('vw-preview-ready', '*');

        // Limpiamos al salir
        return () => {
            window.removeEventListener('message', previewDataReceiver)
        };
    }, [])


    if (previewData === undefined) {
        return (
            <div className="full-viewport mobile">
                <FilkersLoading/>
            </div>
        );
    }

    return (
        <div className="full-viewport mobile">
            <MainPanel
                data={previewData}
                itemUid={selectedItemUid}
                onBackButtonPressed={() => setSelectedItemUid(undefined)}
                onItemSelected={(uid) => setSelectedItemUid(uid)}
            />
        </div>
    );

}


export default PreviewPage;